import { getMandantId } from "../getMandantId.js";
import { isAppMandant } from "../mandanten.js";

/**
 * Prüft anhand der Mandanten-ID des aktuellen Dokuments, ob die Seite in einer App-Webview läuft.
 * @returns {boolean}
 */
export function isAppWebview() {
	const mandantId = getMandantId();
	return isAppMandant(mandantId);
}
